import { createPortal } from "react-dom";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, MyFormData
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function MyContextMenu({
    top, 
    left, 
    width, 
    category, 
    purchase, 
    setContextMenu,  
    update, 
    setPurchaseList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    return createPortal(
    <div className = "contextMenu" style = {{
        position:"absolute", 
        top: top, 
        left: left,
        minWidth: width
    }}>
        {(category === "receipt" && purchase.receiptLink) ||
        (category === "quotation" && purchase.quoteLink) || 
        category === "form"?
        <div onClick = {() => {
            let link = "";
            switch(category){
                case "quotation":
                    link = purchase.quoteLink;
                    break;
                case "receipt":
                    link = purchase.receiptLink;
                    break;
                case "form":
                    link = `https://drive.google.com/file/d/${purchase.formId}/view?usp=drivesdk`;
                    break;
                default:
            }
            window.open(link);
            setContextMenu({show: false});
        }} style = {{borderRadius:"6px 6px 0 0"}}>
            View
        </div>
        :null}
        {(category === "receipt" && purchase.receiptLink) ||
        (category === "quotation" && purchase.quoteLink) || 
        category === "form"?
        <div onClick = {async () => {
            let id = "";
            switch(category){
                case "quotation":
                    id = purchase.quoteLink.split("/")[5];
                    break;
                case "receipt":
                    id = purchase.receiptLink.split("/")[5];
                    break;
                case "form":
                    id = purchase.formId;
                    break;
                default:
            }
            window.open(`https://drive.google.com/uc?export=download&id=${id}`);
        }}>
            Download
        </div>
        :null}
        <div onClick = {() => {
            update();
            setContextMenu({show: false});
        }}>
            {(category === "receipt" && purchase.receiptLink) ||
            (category === "quotation" && purchase.quoteLink) || 
            category === "form"?"Update":"Add"}
        </div>
        {(category === "receipt" && purchase.receiptLink) ||
        (category === "quotation" && purchase.quoteLink)?
        <div onClick = {async () => {
            if(!window.confirm("are you sure to delete this file?")) return;
            // let id = "";
            let type = "";
            switch(category){
                case "quotation":
                    // id = purchase.quoteLink.split("/")[5];
                    type = "quoteLink"
                    break;
                case "receipt":
                    // id = purchase.receiptLink.split("/")[5];
                    type = "receiptLink";
                    break;
                default:
            }
            const formData = new MyFormData();
            formData.append("attachmentType", type);
            formData.append("poNumber", purchase.poNumber);
            //------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("purchases/deleteAttachment.php", formData);
            setShowLoader(false);
            if(!res) return;
            //------------------------------------------------------------
            setContextMenu({show: false});
            setPurchaseList(purchaseList => purchaseList.map(localPurchase => 
                localPurchase.poNumber === purchase.poNumber?
                {...localPurchase, void: "yes", [type]: ""}
                :
                localPurchase
            ));
        }}>
            Delete
        </div>
        :null}
        <div onClick = {() => {
            setContextMenu({show: false});
            
        }}>
            Cancel
        </div>
    </div>, document.getElementById("app-root")
    );
}